import React, { useEffect, useState } from "react";

//helper functions
import { getIndividualClusterInfo } from "./helpers";

//components
import ClusterViewDesktopRowContent from "./ClusterViewDesktopRowContent";

//placeholder
import ClusterRowInfoPlaceholder from "./ClusterRowInfoPlaceholder";

const ClusterViewDesktopRow = ({ cluster, setClusters, clusters }) => {
  //info about each cluster
  const [clusterInfo, setClusterInfo] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const clustersListUrl = `${window.consoleConfig.wcs}/v1/clusters/${cluster}`;
  const access_token = JSON.parse(localStorage.getItem("access_token"));

  //to get data from each individual cluster
  useEffect(() => {
    let mounted = true;

    if (mounted) {
      getIndividualClusterInfo(clustersListUrl, access_token, setClusterInfo);
    }

    //fetches info about the cluster every 12 seconds to update the status
    const interval = setInterval(() => {
      getIndividualClusterInfo(clustersListUrl, access_token, setClusterInfo);
    }, 8000);

    return () => {
      clearInterval(interval);
      mounted = false;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access_token]);

  if (clusterInfo && clusterInfo.data) {
    return (
      <ClusterViewDesktopRowContent
        clusterInfo={clusterInfo}
        setIsDeleteModalOpen={setIsDeleteModalOpen}
        isDeleteModalOpen={isDeleteModalOpen}
        clusters={clusters}
        setClusters={setClusters}
      />
    );
  } else {
    return (
      <tr>
        <td>
          <ClusterRowInfoPlaceholder />
        </td>
      </tr>
    );
  }
};

export default ClusterViewDesktopRow;
